import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m10.5 21.01 5.25-11.25L21 21.01m-9-3h7.5M3 5.63a49 49 0 0 1 6-.37m0 0q1.681 0 3.334.113M9 5.26V3.01m3.334 2.364A18.03 18.03 0 0 1 3 17.512m9.334-12.139q1.344.093 2.666.258m-4.589 8.494a18 18 0 0 1-3.827-5.802"
    }, null, -1)
  ])))
}
export default { render: render }